module.exports = __webpack_public_path__ + "static/media/ISO-BSI.11cc2df4.jpg";